import { render, staticRenderFns } from "./FlagHistory.vue?vue&type=template&id=19faa12c&"
import script from "./FlagHistory.vue?vue&type=script&lang=js&"
export * from "./FlagHistory.vue?vue&type=script&lang=js&"
import style0 from "./FlagHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports